import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';
import './classes/ScoutMyAccount.css';
import ScoutSidebar from './ScoutSidebar';
import SalespersonSidebar from "./SalespersonSidebar";

const scoutAccount = {
    smwwMail:"",
    name:"Testdhanap Test",
    personalMail:"testdhanapnew@preferati.net",
    publicProfile: "https://www.smwwscout.com/scout/testdhanap-test",
}

const MyScoutAccount = () => {

    const [isLoading, setIsLoading] = useState(true); 
    const [scoutAccount, setScoutAccount] = useState({});
    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    const domainName = window.location.host.replace(/^https?:\/\//, '');
    var {uid} = useParams();

    useEffect(() => {
            Promise.all([
                getscoutaccountdetails()
            ])
            .then(() => {
            
                setIsLoading(false);
            })
            
        },[]);
       
        async function getscoutaccountdetails() {
        
           
                const response = await fetch(
                     app_url+'smwwscout/getscoutaccountdetails?uid='+loggedin_uid,
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setScoutAccount(responsedata.data.result);
                }
           
        }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>My Account</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="page-view-myorder">
                            <div className="panel panel-default">
                                <div className="panel-heading" style={{background:"#fefefe"}}>
                                    <h1 style={{marginTop:"0px", marginBottom: "20px"}}>{scoutAccount.name}</h1>
                                </div>
                            
                                <div className="panel-body scout-my-account-body">
                                    <p>Your SMWW mail alias is: <b>{scoutAccount.smwwMail}</b></p>
                                    <p>This is the email address shown on the SMWWScout.com site.</p>
                                    <p>Which directs mail to your personal email of: <b>{scoutAccount.personalMail}</b></p>
                                    <p>The link to your public profile page is:</p>
                                    <p>
                                        <b><a href={scoutAccount.publicProfile} target="_blank" style={{overflowWrap:"break-word"}}>{scoutAccount.publicProfile}</a></b>
                                    </p>
                                    <p>To renew your membership,  <a href={scoutAccount.cart_link} target="">click here</a>.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        {/* <ScoutSidebar /> */}
                        {/* {
                            userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                            userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                            userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE)
                            ? <SalespersonSidebar />
            
                            : domainName === configData.RSMWW_SCOUT_DOMAIN &&
                                userLoggedInRoles.includes(configData.ROLE_SCOUT)
                            ? <ScoutSidebar />
            
                            :<div>
                    <h1>Quick Links</h1>
                    <ul style={{padding: "0px"}}>
                        <li className='salesperson-header-hello-text'><a href={"/user/"+userLoggedInId.drupal_uid+"/edit"} className="salesperson-quick_link_anchor">Manage My Profile</a></li>
                        <li>
                        <a href="/smww_pay">
                        <input type="button" className='salesperson-quick-links-reg-button' value="Register for a Course"/>
                        </a>
                        </li>           */}
                        {/* {localStorage.getItem('masquerade') == 1 && (
                            <li>
                            <a className="salesperson-quick_link_anchor" href={/miscellaneous/charge/${drupal_uid}}>
                                Miscellaneous Charge
                            </a>
                            </li>
                        )} */}
                    {/* </ul>
                  </div>
                        } */}
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default MyScoutAccount;